<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          :parentType="parentType"
          :parentCode="parentCode"
          @finish="onfinish"
          @close="closeModifyPopup"
        >
        </modify-popup>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                {
                  title: $t('AccountGeneralTitle'),
                  sort: 'AccountGeneralTitle',
                },
                { title: $t('AccountCode'), sort: 'AccountCode' },
                { title: $t('Description'), sort: 'Description' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.title }}
                </td>
                <td style="direction: ltr">
                  {{ row.code }}
                </td>
                <td>
                  {{ row.description ? row.description : "-" }}
                </td>
                <!-- <td>
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click.prevent="editAccount(row)"
                      class="ml-4 d-inline"
                    ></vs-button>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteAccount(row.id)"
                      class="d-inline"
                    ></vs-button>
                  </td> -->
                <td>
                  <vs-button
                    flat
                    color="primary"
                    tooltip="hello"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    @click.prevent="createAccount(row.id , row.code)"
                    class="d-inline"
                    v-has-permission="'CreateSubsidiaryAccount'"
                  >
                    {{ $t("CreateNewSubsidiaryAccount") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./CreateGeneralPopup.vue";
import moment from "moment";
export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      itemList: [],
      parentType: 0,
      parentCode: 0,
      gridDataSource: {
        type: "app",
        service: "Credits/api/GeneralAccountsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeAccount: "generalAccount/remove",
    }),
    ////Open Modal In Create Mode
    createAccount(id , code) {
      this.modalModel = {};
      this.parentType = id; 
      this.parentCode = code; 
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editAccount(model) {
      this.modalModel = { id: model.id, name: model.name };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteAccount(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeAccount(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
